// Howzzat (Cricket) — identical to the Defender theme except the accent, which
// swaps the football pitch-green for the cricket "men-in-blue" royal blue. Every
// other token references the accent via var(), so overriding just the accent
// token here cascades to buttons, active states, the spinner, etc.
import { DEFAULT as DEFENDER_DEFAULT } from '../defender/default'

const CRICKET_ACCENT = '#2E7CF6'

export const DEFAULT = {
  NORMAL: {
    ...DEFENDER_DEFAULT.NORMAL,
    '--standard-normal-accent-color': CRICKET_ACCENT,
    '--standard-normal-app-how-to-play-accent-color': CRICKET_ACCENT,
  },
  MINI: {
    ...DEFENDER_DEFAULT.MINI,
    '--standard-mini-accent-color': CRICKET_ACCENT,
  },
}
